import { useQuery } from '@tanstack/react-query';
import { sprintMetricGql } from './query';

export const QUERY_KEYS = {
  allDoraThreshold: 'allDoraThreshold',
};

export const useSprintList = (
  startDate: string,
  endDate: string,
  teamId: string,
  repos: string[],
  sprintId: string,
  sprintIds: string[],
  pageSize: number,
  pageNumber: number,
  bySp: boolean,
  status: string,
  type: string
) => {
  return useQuery(
    [
      QUERY_KEYS.allDoraThreshold,
      startDate,
      endDate,
      pageSize,
      pageNumber,
      teamId,
      repos,
      sprintId,
      sprintIds,
      bySp,
      status,
      type,
    ],
    () =>
      sprintMetricGql(
        startDate,
        endDate,
        teamId,
        repos,
        sprintId,
        sprintIds,
        pageSize,
        pageNumber,
        bySp,
        status,
        type
      ),
    {
      select: (data) => {
        return {
          ...data?.SprintMetricsWithStatus,
          reports: data?.SprintMetricsWithStatus?.reports?.map((el: any) => ({
            ...el,
            sprintVelocity: {
              chart: JSON.parse(el.sprintVelocity.chart),
            },
          })),
        };
      },
      enabled: !!startDate && !!endDate,
      keepPreviousData: true,
    }
  );
};
